import { DateRecord } from "../../../../../types/immutableRecords/model/data/DateRecord";
import dateFunctions, { isDateEarlierThan,isDateValid } from "../../../../definition/calendar/dateFunctions";
import dateByAddingSpan from "../../../../definition/calendar/dateFunctions/dateByAddingSpan";
import dateSubtractionFunctions from "../../../../definition/calendar/dateFunctions/dateSubtractionFunctions";
import { isTimespanZero } from "../../../../definition/calendar/dateFunctions/timespanFunctions";
import { setTimespanProp } from ".";

export const setItemPreferredStartDate = (
  obj,
  newStartDate,
  calendar,
  autoAdjustEnd,
  changePreferredPrecision = false
) => {
  if (obj.isDateLocked) {
    return obj;
  }
  let newObj = obj;
  const oldStartDate = obj.preferredStartDate;
  const latestStartDate = newObj.latestStartDate;

  if (!isDateValid(newStartDate)) {
    // When clearing preferred start date
    // should take the latestStartDate if it exists

    if (isDateValid(oldStartDate) && isDateValid(latestStartDate)) {
      newObj = newObj.merge({ preferredStartDate: latestStartDate, latestStartDate: null });
    } else {
      newObj = newObj.set("preferredStartDate", DateRecord());
    }
  } else {
    if (autoAdjustEnd) {
      if (isDateValid(latestStartDate)) {
        // Should adjust latest start by the difference between new date and the old date
        // Note: latestStartDate valid implies the old start date is valid
        const preferredDiff = dateSubtractionFunctions.timespanBetweenDates(calendar, oldStartDate, newStartDate);
        newObj = newObj.set("latestStartDate", dateByAddingSpan(calendar, latestStartDate, preferredDiff));
      }
      if (isDateValid(obj.earliestEndDate)) {
        newObj = newObj.set("earliestEndDate", dateByAddingSpan(calendar, newStartDate, obj.durationToEarliestEnd));
      }
      if (isDateValid(obj.preferredEndDate)) {
        newObj = newObj.set("preferredEndDate", dateByAddingSpan(calendar, newStartDate, obj.preferredDuration));
      }
      newObj = newObj.set("preferredStartDate", newStartDate);
    } else {
      if (!isDateValid(oldStartDate)) {
        // Old start date does not exist implies no other dates exist
        newObj = newObj.set("preferredStartDate", newStartDate);
      } else {
        const preferredDuration = obj.preferredDuration;
        const durationToEarliestEnd = obj.durationToEarliestEnd;
        const endDate = dateFunctions.dateByAddingSpan(calendar, oldStartDate, preferredDuration);
        const earliestEndDate = durationToEarliestEnd
          ? dateFunctions.dateByAddingSpan(calendar, oldStartDate, durationToEarliestEnd)
          : null;

        const updateDurations = () => {
          // update the durations to keep the end dates
          newObj = newObj.set("preferredStartDate", newStartDate);
          newObj = setTimespanProp(
            newObj,
            dateSubtractionFunctions.timespanBetweenDates(calendar, newStartDate, endDate),
            "preferredDuration"
          );
          if (durationToEarliestEnd) {
            newObj = setTimespanProp(
              newObj,
              dateSubtractionFunctions.timespanBetweenDates(calendar, newStartDate, earliestEndDate),
              "durationToEarliestEnd"
            );
          }
        };

        if (isDateValid(latestStartDate)) {
          if (isDateEarlierThan(calendar, newStartDate, latestStartDate)) {
            updateDurations();
          } else if (isTimespanZero(preferredDuration)) {
            newObj = newObj.set("preferredStartDate", newStartDate);
            newObj = newObj.set("latestStartDate", newStartDate);
          }
        } else if (durationToEarliestEnd) {
          if (isDateEarlierThan(calendar, newStartDate, earliestEndDate)) {
            updateDurations();
          } else if (isTimespanZero(preferredDuration)) {
            newObj = newObj.set("preferredStartDate", newStartDate);
          }
        } else if (isDateEarlierThan(calendar, newStartDate, endDate)) {
          updateDurations();
        } else if (isTimespanZero(preferredDuration)) {
          newObj = newObj.set("preferredStartDate", newStartDate);
        }
      }
    }
  }

  if (changePreferredPrecision) {
    newObj = newObj.set("preferredPrecision", newStartDate.precision);
  }
  return newObj;
};
